<template>
  <v-app>
    <div v-if="isLoggedIn">
      <lean-navigation />
      <v-main>
        <v-container v-if="ready" fluid class="pa-0">
          <router-view :config="config"></router-view>
        </v-container>
      </v-main>
    </div>
    <div v-else>
      <lean-login />
    </div>
    <v-snackbar v-model="snackbarStatus" :timeout="5000" bottom>
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn :color="snackbar.type === 'error' ? 'red' : 'green'" text v-bind="attrs" @click="clearSnackbar()">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import AWS from 'aws-sdk';
import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';
import { mapMutations, mapState, mapGetters } from 'vuex';
import LeanNavigation from '@/components/navigation/LeanNavigation';
import LeanLogin from '@/components/LeanLogin';
import LeanCMSAdminSDK from '@/helpers/LeanCMSAdminSDK';

export default {
  name: 'App',
  components: { LeanNavigation, LeanLogin },
  data: () => ({
    cognitoUser: null,
    ready: false
  }),
  computed: {
    ...mapGetters('cognito', ['isLoggedIn']),
    ...mapState({
      isSessionLoaded: 'isSessionLoaded',
      snackbar: (state) => state.snackbar,
      awsExports: 'awsExports'
    }),
    models: {
      get() {
        return this.$store.state.models;
      },
      set(value) {
        this.setModels(value);
      }
    },
    config: {
      get() {
        return this.$store.state.config;
      },
      set(value) {
        this.$root.$i18n.locale = value.languages[0].split('_').shift().toLowerCase();
        this.setConfig(value);
      }
    },
    snackbarStatus: {
      get() {
        return this.snackbar.show;
      },
      set(value) {
        this.changeSnackbarStatus(value);
      }
    }
  },
  methods: {
    ...mapMutations({
      setSearch: 'setSearch',
      setModels: 'setModels',
      initSdk: 'initSdk',
      setConfig: 'setConfig',
      setSnackbar: 'setSnackbar',
      clearSnackbar: 'clearSnackbar',
      changeSnackbarStatus: 'changeSnackbarStatus',
      isLoading: 'isLoading'
    }),
    setCognitoUser() {
      return new Promise((resolve, reject) => {
        // Initialize Pool
        var userPool = new AmazonCognitoIdentity.CognitoUserPool({
          UserPoolId: this.awsExports.Auth.userPoolId,
          ClientId: this.awsExports.Auth.userPoolWebClientId
        });

        // Get User
        this.cognitoUser = userPool.getCurrentUser();

        if (this.cognitoUser != null) {
          // Get Session
          this.cognitoUser.getSession((err, result) => {
            // initialize aws-sdk
            if (err) {
              return reject(err);
            }
            AWS.config.region = this.awsExports.aws_project_region;
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
              IdentityPoolId: this.awsExports.identity_pool_id,
              Logins: {
                ['cognito-idp.' +
                this.awsExports.aws_project_region +
                '.amazonaws.com/' +
                this.awsExports.Auth.userPoolId]: result.getIdToken().getJwtToken()
              }
            });
            resolve(result);
          });
        } else {
          reject('no cognito User');
        }
      }).catch((err) => {
        console.error(err);
        this.setSnackbar({ message: 'no cognito User', type: 'error' });
      });
    },
    async loadModels() {
      // list all models
      const result = await this.$store.state.sdk.s3.getObject({ Key: 'index.json' }).promise();

      try {
        this.config = JSON.parse(result.Body.toString());
      } catch (err) {
        console.error(`failed to read global config ${result.Body.toString()}`, err);
        throw err;
      }
      this.models = this.config.models;
    }
  },
  watch: {
    async isLoggedIn(value) {
      if (value) {
        await this.setCognitoUser();
        this.initSdk(new LeanCMSAdminSDK(this.awsExports));
        await Promise.all([this.loadModels(), this.$store.state.sdk.getSQSPublisherUrl()]);
        this.ready = true;
      }
    }
  }
};
</script>

<style lang="scss">
.lcms-file-input {
  position: relative;
}
.lcms-file-input-clear {
  display: block;
  position: absolute;
  top: 9px;
  right: 9px;
}
</style>
